export default __webpack_public_path__ + "static/media/gm-gp-girl.8aad4193.webp";